import { Injectable } from '@angular/core';
import { WellExplorerItem } from '../models/well-explorer.model';
import { Observable, tap } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { WellType } from 'src/app/shared/models/wellType.model';
import { Design } from 'src/app/shared/models/design.model';

const PeriforApiEndpoint = `${environment.PeriforEndpoint}/api`;

@Injectable({
  providedIn: 'root'
})
export class WellExplorerService {
  private wellExplorerCache$: Observable<WellExplorerItem> | null = null;

  constructor(private http: HttpClient) { }

  // -- Well Explorer API --
  public getWellExplorer(): Observable<WellExplorerItem> {
    if (!this.wellExplorerCache$) {
      this.wellExplorerCache$ = this.http.get<WellExplorerItem>(`${PeriforApiEndpoint}/wellexplorer`).pipe(
        shareReplay(1)
      );
    }
    setTimeout(() => this.wellExplorerCache$ = null, 1000);
    return this.wellExplorerCache$;
  }

  public invalidateCache(): void {
    this.wellExplorerCache$ = null;
  }

  public addCompany(model: { parentId: string, level: string, name: string }): Observable<string> {
    return this.http.post<string>(`${PeriforApiEndpoint}/wellexplorer/create-company`, model);
  }

  public createTreeLevel(model: { parentId: string, level: string, name: string }): Observable<string> {
    return this.http.post<string>(`${PeriforApiEndpoint}/wellexplorer/create-item`, model);
  }

  public renameTreeLevel(model: { id: string, level: string, name: string }) {
    return this.http.put<string>(`${PeriforApiEndpoint}/wellexplorer/${model.id}/rename`, model)
  }

  public deleteTreeLevel(id: string) {
    return this.http.delete<boolean>(`${PeriforApiEndpoint}/wellexplorer/${id}/remove`)
  }

  // -- End Well Explorer API --

  // -- Design Related 
  public getCurrentDesign(wellboreId:string): Observable<Design>{
    return this.http.get<Design>(`${PeriforApiEndpoint}/wellbores/${wellboreId}/designs`);
  }

  public addDesign(model: { parentId: string, level: string, name: string, wellType: WellType, dashboardDesignId: string, organization: string }): Observable<string> {
    return this.http.post<string>(`${PeriforApiEndpoint}/wellexplorer/create-design`, model);
  }

  public cloneDesign(designId:string, wellboreId:string, designName:string) :Observable<string> {
    return this.http.post<string>(`${PeriforApiEndpoint}/wellbores/${wellboreId}/designs/${designId}/clone`, { name: designName });
  }

  public importDesign(wellboreId: string, design: any) : Observable<string>{
    return this.http.post<string>(`${PeriforApiEndpoint}/wellbores/${wellboreId}/designs/import`, design);
  }

  public exportDesign(designId, wellboreId, designName): Observable<any> {
    return this.http.get(`${PeriforApiEndpoint}/wellbores/${wellboreId}/designs/${designId}/export?name=${designName}`);
  }
  // -- End Design Related

  // -- Move Well Explorer Items (Generic endpoint for all levels below Company)
  public moveWellExplorerItem(itemId: string, moveDto: any): Observable<boolean> {
    return this.http.post<boolean>(`${PeriforApiEndpoint}/wellexplorer/${itemId}/move`, moveDto);
  }
  // -- End Move Well Explorer Items

}
